export const themeOpts = [
    "DefaultLight",
    "DefaultDark",
    "DefaultLightPanelless",
    "DefaultDarkPanelless",
    "SharpLight",
    "SharpDark",
    "SharpLightPanelless",
    "SharpDarkPanelless",
    "BorderlessLight",
    "BorderlessDark",
    "BorderlessLightPanelless",
    "BorderlessDarkPanelless",
    "FlatLight",
    "FlatDark",
    "FlatLightPanelless",
    "FlatDarkPanelless",
    "PlainLight",
    "PlainDark",
    "PlainLightPanelless",
    "PlainDarkPanelless",
    "DoubleBorderLight",
    "DoubleBorderDark",
    "DoubleBorderLightPanelless",
    "DoubleBorderDarkPanelless",
    "LayeredLight",
    "LayeredDark",
    "LayeredLightPanelless",
    "LayeredDarkPanelless",
    "SolidLight",
    "SolidDark",
    "SolidLightPanelless",
    "SolidDarkPanelless",
    "ThreeDimensionalLight",
    "ThreeDimensionalDark",
    "ThreeDimensionalLightPanelless",
    "ThreeDimensionalDarkPanelless",
    "ContrastLight",
    "ContrastDark",
    "ContrastLightPanelless",
    "ContrastDarkPanelless",
];
